import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span
} from 'components'
import { IGetAdesaoTable } from 'services/NGT/EffectiveConsolidation'
import { COLORS } from 'utils'

import { FormatAdhesionTableData as FormatTData} from '../../utils/FormatAdhesionTableData'
import { CollapsibleTable } from '../CollapsibleTable/CollapsibleTable'

interface IReportTable {
  tableData: IGetAdesaoTable
  titleHeader: string
  isGeneratePDF: boolean
}

export const ReportTable = ({
  tableData,
  titleHeader,
  isGeneratePDF
}: IReportTable) => {
  FormatTData.formatarTableData(tableData)
  FormatTData.formatarSubItens(tableData)
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled backgroundColor={COLORS.blueFonts}>
              <TableCellStyled
                align="center"
                textColor={COLORS.white}
                colSpan={2}
              >
                {titleHeader}
              </TableCellStyled>
              <TableCellStyled
                align="center"
                textColor={COLORS.white}
                colSpan={8}
              >
                ADESÃO
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled colSpan={2} />
              <TableCellStyled align="center">
                Mobilizados no Mês
              </TableCellStyled>
              <TableCellStyled align="center">
                Qtde de Fornecedor
              </TableCellStyled>
              <TableCellStyled align="center">N° de Contratos</TableCellStyled>
              <TableCellStyled align="center">
                N° de SubContratos
              </TableCellStyled>
              <TableCellStyled align="center">
                Total (Contrato+Sub)
              </TableCellStyled>
              <TableCellStyled align="center">
                Total de Contrapartes
              </TableCellStyled>
              <TableCellStyled align="center">
                Contrapartes que Não Preencheram
              </TableCellStyled>
              <TableCellStyled align="center">
                N° de Contrapartes(%)
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.itensConsolidacao.length > 0 &&
              tableData?.itensConsolidacao.map((row, index) => (
                <CollapsibleTable
                  key={index}
                  row={row}
                  isGeneratePDF={isGeneratePDF}
                />
              ))}

            <TableRowStyled backgroundColor={COLORS.tableColor}>
              <TableCellStyled colSpan={2}>
                <Span text="TOTAL:" fontWeight="bold" />
              </TableCellStyled>

              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtMobilizacaoMensal)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtFornecedor)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtContratoPrincipal)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtSubContrato)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtTotalContratos)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtTotalContrapartes)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtContraparteNaoPreencheu)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.peContrapartes)}%
              </TableCellStyled>
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
    </>
  )
}
